import m from "./../../../dist/es2015/locales/ro_RO.js";
export const am5locales_ro_RO = m;